import React from "react";
import BaseField from "./BaseField"
import { Form } from "react-bootstrap";

export default function TextField(props){
  const { action, resource, name, label, value, col, onChange, required } = props;
  
  return(
    <BaseField action={action} resource={resource} required={required} name={name} label={label} value={value} col={col}>
      <Form.Control className="pl-1 pb-2 text-black" as={props.as} type="text" value={value || ""} onChange={onChange}/>
    </BaseField>
  )
}